import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { addNewSetting, updateLastSetting, updateSettingsIds } from '../../../store/actions/settings.actions'
import { getLastPhysicsSetting } from '../../../helpers/util'
import { sendMetric } from '../../../helpers/metric'
import { rotate, flip } from '../../../helpers/flipRotate'
import { ReactComponent as RotateLeftIcon } from '../../../assets/images/icons/i-rotate-left.svg'
import { ReactComponent as RotateRightIcon } from '../../../assets/images/icons/i-rotate-right.svg'
import { ReactComponent as HorizontalFlipIcon } from '../../../assets/images/icons/i-horizontal-flip.svg'
import { ReactComponent as VerticalFlipIcon } from '../../../assets/images/icons/i-vertical-flip.svg'
import TileButton from '../../Common/Buttons/TileButton/TileButton'
import Button from '../../Common/Buttons/Button/Button'

import './RotateControl.scss'

import * as Sentry from '@sentry/react'

class RotateControl extends PureComponent {
  static propTypes = {
    imageData: PropTypes.object.isRequired,
    settingsList: PropTypes.array.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    addNewSetting: PropTypes.func.isRequired,
    updateSettingsIds: PropTypes.func.isRequired,
    dispatchUpdateLastSetting: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  }

  onApply = () => {
    const {
      settingsList,
      currentSettingId,
      dispatchUpdateLastSetting
    } = this.props
    const lastSetting = getLastPhysicsSetting(settingsList, currentSettingId)

    dispatchUpdateLastSetting({
      ...lastSetting,
      isCommitted: true,
    })
  }

  rotateAndFlipImage = (direction) => {
    const {
      imageData,
      settingsList,
      currentSettingId,
      addNewSetting,
      updateSettingsIds,
      dispatchUpdateLastSetting
    } = this.props
    const lastSetting = getLastPhysicsSetting(settingsList, currentSettingId)
    const data = lastSetting ? lastSetting.imageData : imageData

    try {
      const isRotate = direction === 270 || direction === 90
      const resultData = isRotate ? rotate(data, direction) : flip(data, direction)

      sendMetric({
        event: isRotate ? 'ROTATE_APPLIED' : 'FLIP_APPLIED',
        gtm: {
          eventCategory: 'Interactions',
          eventAction: 'click',
          eventLabel: isRotate ? 'ROTATE_APPLIED' : 'FLIP_APPLIED'
        },
        amplitude: {}
      })

      if (!lastSetting || lastSetting.isCommitted) {
        updateSettingsIds(currentSettingId + 1)
        addNewSetting({
          name: 'rotate',
          isCommitted: false,
          id: currentSettingId + 1,
          imageData: resultData,
        })
      } else {
        dispatchUpdateLastSetting({
          ...lastSetting,
          imageData: resultData,
        })
      }
    } catch (e) {
      Sentry.captureException(e)
      console.error(e)
    }
  }

  render() {
    const {
      t,
      settingsList,
      currentSettingId,
    } = this.props
    const lastSetting = getLastPhysicsSetting(settingsList, currentSettingId)

    return (
      <div className="rotate-control">
        <div className="rotate-control__title">
          {t('titles.rotate')}
        </div> 
        <div className="rotate-control__control-wrapper">
          <p className="rotate-control__control-name">{t('controls.rotate')}</p>
          <div className="rotate-control__buttons-wrapper">
            <TileButton
              onClick={() => this.rotateAndFlipImage(270)}
            >
              <RotateLeftIcon />
            </TileButton>
            <TileButton
              onClick={() => this.rotateAndFlipImage(90)}
            >
              <RotateRightIcon />
            </TileButton>
          </div>
        </div>
        <div className="rotate-control__control-wrapper rotate-control__control-wrapper_flip">
          <p className="rotate-control__control-name">{t('controls.flip')}</p>
          <div className="rotate-control__buttons-wrapper">
            <TileButton
              onClick={() => this.rotateAndFlipImage('horizontal')}
            >
              <HorizontalFlipIcon />
            </TileButton>
            <TileButton
              onClick={() => this.rotateAndFlipImage('vertical')}
            >
              <VerticalFlipIcon />
            </TileButton>
          </div>
        </div>
        <Button
          block
          disabled={!lastSetting || lastSetting.isCommitted}
          onClick={this.onApply}
        >
          {t('buttons.apply')}
        </Button>
      </div>
    )
  }
}

const mapStateToProps = ({ imageStore: { imageData }, settingsStore: { settingsList, currentSettingId } }) => ({
  imageData,
  settingsList,
  currentSettingId,
})

const mapDispatchToProps = (dispatch) => ({
  addNewSetting: (setting) => dispatch(addNewSetting(setting)),
  dispatchUpdateLastSetting: (setting) => dispatch(updateLastSetting(setting)),
  updateSettingsIds: (id) => dispatch(updateSettingsIds(id)),
})

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(RotateControl))
